<template>
  <div v-if="!loading" class="card" style="max-height:400px;overflow-y:auto;">
    <div v-if="data && data.length" class="card-body p-2">
      <ul class="nav">
        <li
          class="nav-item"
          v-for="item in data"
          v-bind:key="item.id + Math.random(1024)"
        >
          <a class="nav-link mb-1" @click="() => handleClick(item)">
            <div class="left">
              <h5 :class="'mb-0'">
                {{
                item.tipe
              }} {{ item.kode }}{{(item.subkode?`.${item.subkode}`:'')}} - {{ item.desc_short }}
              </h5>
            </div>
            <div class="right">
              <h5 class="mb-0 text-success text-right">
                {{ item.desc_long }}
              </h5>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div v-else class="p-2">
      <center>tidak ditemukan hasil pencarian</center>
    </div>
  </div>
  <div v-else class="card">
    <div class="p-2">
      <center>Sedang melakukan pencarian..</center>
    </div>
  </div>
</template>
<style scoped>
.nav {
  width: 100%;
}
.card {
  position: absolute;
  width: 95.375%;
  z-index: 9999;
}
.nav-item {
  width: 100%;
}
.nav-link {
  margin-right: 0;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
}
.nav-item:last-child .nav-link {
  margin-right: 0;
  margin-bottom: 0;
}
.nav-link:hover {
  background: rgba(22, 160, 133, 0.12);
}
</style>
<script>
import { convertToRupiah } from "@/data/helper.js";
export default {
  name: "SearchResultMedical",
  components: {},
  props: {
    data: Array,
    loading: Boolean
  },
  data: function() {
    return {
      convertToRupiah: convertToRupiah
    };
  },
  methods: {
    handleClick(item) {
      this.$emit("addItem", item);
    }
  }
};
</script>
